<template>
  <header 
    js-noremove
    class="header">
    <div 
      class="header__wrapper"
      :class="this.bg ? 'bg-hide' : false"
    >
      <Weather />

      <div class="header__nav">
        <Social />
        <SwitchLang />
      </div>
    </div>

    <Cta 
      :btn="btn"
      class="btn-js btn--back"
      js-refPage="event"
      :class="$route.name !== 'event' ? 'hide': false"
    />
  </header>
</template>

<script>
import store from '@/store';
import { mapGetters } from 'vuex';

import Weather from '@/components/header/Weather';
import Social from '@/components/header/Social';
import SwitchLang from '@/components/header/SwitchLang';
import Cta from '@/components/utils/Cta';

import { qs, isMobile, isDevice } from '@/scripts/utils';


export default {
  name: 'Header',

  components: {
    Weather,
    Social,
    SwitchLang,
    Cta,
  },

  computed: {
    ...mapGetters({
      lang: 'getLang',
      loaded: 'getPageLoaded',
    }),

    text() {
      const text = this.lang === 'it' ? 'tieni premuto' : 'hold on';

      return text;
    },
  },

  data() {
    return {
      isMobile,
      isDevice,
      bg: false,

      btn: {
        symbol: 'close',
        link: `/${store.state.lang}`,
        it: {
          textPrimary: 'torna',
          textAlt: 'indietro',
        },
        en: {
          textPrimary: 'back',
          textAlt: 'home',
        },
      },
    };
  },

  watch: {
    lang(newVal) {
      if (newVal) {
        this.btn.link = `/${newVal}`;
      }
    },
  },

  mounted() {
    if (!isMobile()) this.$el.style.opacity = 0;
    this.bgHide();

    this.$eventHub.$on('windowResized', this.bgHide);
    if (isMobile()) qs('.app__wrapper').addEventListener('scroll', this.bgHide);

    this.$store.commit('ADD_BUTTONS', this.$el);
  },

  methods: {
    bgHide() {
      this.bg = qs('.app__wrapper').scrollTop <= 40;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../application';

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  z-index: z-index(header);

  @include mq(sm) {
    padding: 15px 30px 35px;
  }


  @include mq($from: md, $and: $is-820) {
    padding: 45px 30px 0;
  }

  @media (max-width: 1440px) and (max-height: 900px) and (min-width: 941px) {
    padding: 15px 30px 35px;
  }

  -webkit-touch-callout: none;
  -webkit-user-select: none;
   -khtml-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;

  &__wrapper {
    position: relative;
    max-width: $container-width;
    margin: 0 auto;
    padding: 10px 10px 20px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background: $color-light;
      -webkit-mask: linear-gradient(to top,rgba(0,0,0,.1) 0,rgba(0,0,0,1) 25px,#000 100px);

      transition: all 0.15s ease-out;
      transform-origin: 0 0;
      transform: scaleY(1);

      z-index: -1;
    }

    @include mq(xxs) {
      padding: 10px 30px 20px;
    }

    @extend %flex;
    align-items: center;
    justify-content: space-between;

    @include mq(sm) {
      padding: 0;

      &::before {
        content: none;
      }

    }

    &.bg-hide {

      &::before {
        transform: scaleY(0);
      }
    }
  }

  .hold {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translateX(-50%) translateY(-50%);

    p {
      position: relative;
    }

    &.hide {
      pointer-events: none;
    }
  }

  &__nav {
    @extend %flex;
    align-items: center;
  }

  .btn--back {
    position: fixed;
    bottom: 0;
    left: 50%;

    transform: translate3d(-50%, -10px, 0);

    &.hide {
      pointer-events: none;
    }

    @include mq(sm) {
      top: 0;
      bottom: auto;

      transform: translate3d(-50%, 3px, 0);
    }

    @include mq($from: md, $and: $is-820) {
      transform: translate3d(-50%, 33px, 0);
    }

    @media (max-width: 1440px) and (max-height: 900px) and (min-width: 941px) {
      transform: translate3d(-50%, 3px, 0); 
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue